module.exports = __webpack_public_path__ + "img/Sardinia.71880f96.svg";